import SelectCardApi from "@/api/cardBind";
import { Component, Vue } from "vue-property-decorator";

const style = require("./index.module.scss");

interface UserInfoVo {
  phone: string;
  userName: string;
  idCardNo: string;
}
@Component({ name: "YXHContract" })
export default class YXHContract extends Vue {
  private userInfoMation: UserInfoVo = {
    phone: "",
    userName: "",
    idCardNo: "",
  };

  private async created() {
    const userInfo = await SelectCardApi.getUserInfomation();
    if (userInfo) {
      this.userInfoMation.userName = userInfo.userName;
      this.userInfoMation.idCardNo = userInfo.idCardNo;
    }
  }

  // 年月日
  private renderDate() {
    const d = new Date();
    return `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日`;
  }

  private render() {
    return (
      <div class={style.YXHContract}>
        <p class={style.title}>
          <strong>个人征信查询授权书</strong>
        </p>
        <p>
          <strong>重要提示：</strong>
        </p>
        <p>
          <strong>
            &nbsp;&nbsp;尊敬的客户：为了维护您的利益，在您签署本授权书之前，仔细阅读本授权书各条款，关注您在授权书中的权利、义务。若有任何疑问，可向经办人员咨询。
          </strong>
        </p>
        <p>
          海南宜信普惠小额贷款有限公司、恒诚科技发展（北京）有限公司、宜信惠民投资管理（北京）有限公司（
          <strong>以下简称“贵司”</strong>）：
        </p>
        <p>
          <strong>
            &nbsp;&nbsp;本人完全理解同意并不可撤销的授权，贵司在发生与本人有关的下列情形时，可以通过姓名或名称、证件类型、证件号码等信息向中国人民银行征信中心、百行征信有限公司、中国互联网金融协会互联网金融信息共享平台及该平台的信息共享合作伙伴及其他依法设立的第三方征信机构查询并打印、留存及使用本人所有的个人信用信息资料、审核本人或配偶的个人贷款/借款申请；
          </strong>
        </p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;（一）、审核本人或配偶作为担保人的；</p>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;（二）、对本人或配偶名下已存在的个人贷款进行贷后管理；
        </p>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;（三）、对本人借款申请业务或者作为担保人的业务进行贷后风险管理；
        </p>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;（四）、受理本人担任法定代表人、负责人或出资人的法人或其他组织的借款申请的；
        </p>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;
          五）、受理本人担任法定代表人、负责人或出资人的法人或其他组织作为担保人的。
        </p>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;（六）经中国互联网金融协会同意的其他情况。
        </p>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;
          同时授权贵司可以将本人的个人信用信息向中国人民银行征信中心、百行征信有限公司、中国互联网金融协会互联网金融信息共享平台及该平台的信息共享合作伙伴及其他依法设立的第三方征信机构（以下简称“征信机构”）报送或共享本人相关信息，具体如下：
        </p>
        <p>
          <strong>
            （一）本人同意并授权贵司向征信机构报送本人信用信息，并同意征信机构获取、保存、分析处理该信用信息，
          </strong>
          报送的信用信息包括但不限于主体信息、借款信息、还款信息、逾期信息,以及以虚假主体或仿冒他人名义申请借款、提供虚假申请资料等欺诈信息。
        </p>
        <p>
          <strong>
            （二）本人同意并授权贵司及征信机构可在本人借款业务申请阶段及业务存续期间向征信机构查询本人的相关信息
          </strong>
          (即历史信息、不良信息、借款信息、还款信息、逾期信息
          、账户数额、违约信息)以用来进行贷前审批和贷后管理。
        </p>
        <p>
          <strong>
            （三）本人同意征信机构可向被授权人和有关部门、单位（包括但不限于公安、司法、教育、全国公民身份证号码查询服务中心、通信运营商、社保、公积金、税务、民政、物流、电子商务平台、互联网平台、行业协会等合法留存本人信息的第三方机构等）采集、查询或验证本人信息，并可将采集或查询到的本人信息在本授权书第一条所列的情形下向被授权人提供。
          </strong>
        </p>
        <p>
          本授权书所称的信息共享合作伙伴指与贵方共同加入中国互联网金融协会互联网金融信息共享平台的其他单位。本授权书所指的本人信息包括本人基本信息、本人信贷信息以及与本人信用相关的其他信息。
        </p>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;本授权书自签署之日起生效，有效期至本人贷款结清之日止。
        </p>
        <p>
          <strong>
            本人声明：已经完全知悉并充分理解本授权书的内容及法律后果，并愿意接受本授权书的约定。
          </strong>
        </p>
        <p> 授权人签名：{this.userInfoMation.userName}</p>
        <p class={style.idCard}>身份证号码：{this.userInfoMation.idCardNo}</p>
        <p>日 期：{this.renderDate()}</p>
      </div>
    );
  }
}
